export const IndividualReportNoDailyActivity = () => {
  return (
    <div className="tw-bg-neutral-50 tw-p-5 tw-rounded-xl tw-border-[2px] tw-border-solid tw-border-neutral-200">
      <h4 className="tw-text-center">No learning activity this week</h4>
      <p className="tw-text-center">
        Learning activity will appear here once they begin working on lessons, practice problems, or challenges.
      </p>
    </div>
  );
};
